module.exports = __webpack_public_path__ + "static/media/ellipsis-v.79f55121.svg";